import { render, staticRenderFns } from "./SingleTransactionPayment.vue?vue&type=template&id=1e4939b4&"
import script from "./SingleTransactionPayment.vue?vue&type=script&lang=js&"
export * from "./SingleTransactionPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports